import { Component, OnDestroy } from '@angular/core';
import { WithDestroy } from '@lib/shared';
import { environment } from '@env/environment';
import { MetadataService } from '../../../services/metadata.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends WithDestroy() implements OnDestroy {
  public privacyPolicyUrl = environment.privacyPolicyUrl;
  public termsOfUseUrl = environment.termsOfUseUrl;
  public nmlsConsumerAccessUrl = environment.nmlsConsumerAccessUrl;
  public companyNmls: string;
  public complianceLogoUrl: string;
  // public brokerUserNmls: string;

  constructor(private metadataService: MetadataService) {
    super();
    this.companyNmls = this.metadataService.metadata.WizeOrgUnit.Broker.nmlsNumber;
    this.complianceLogoUrl = this.metadataService.metadata.WizeOrgUnit.complianceLogo;
    // this.brokerUserNmls = /^\d+$/.test(route.snapshot.params.nmls) ? route.snapshot.params.nmls : '';
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
